import React, { useState } from 'react';
import { swatchCss } from 'src/components/ProductDetail/utils/swatchData';
import classnames from 'classnames';
import { Tooltip } from 'react-tooltip';

import { Swatch } from '../../ProductDetail/ProductSwatch';
import { SwatchOption } from '../../Swatch/SwatchOption';
import classes from '../../ProductDetail/ProductSwatch.scss';
type BasketUpsellProductSwatchProps = {
    swatches: Swatch[];
    setColor: React.Dispatch<any>;
    color: number;
    showMore: boolean;
};

export const BasketUpsellProductSwatch: React.FC<BasketUpsellProductSwatchProps> = ({
    swatches,
    setColor,
    color,
    showMore,
}) => {
    const swatchTotal = swatches.length;

    const swatchItems = swatches.map((swatch) => {
        const css = swatchCss(swatch.swatch_data);

        return (
            <SwatchOption
                htmlFor={`swatch-${swatch.value_index}`}
                key={swatch.title}
                optionName={swatch.title}
                labelClassName={classes.swatchesItemLabel}
                onClick={() => setColor && setColor(swatch.value_index)}
                input={
                    <input checked={swatch.value_index === color} type="radio" className={classes.swatchesItemInput} />
                }
            >
                <span
                    className={classes.swatchReactTip}
                    style={css}
                    data-tooltip-id={`upsell-swatch-${swatch.value_index}`}
                    data-tooltip-content={swatch.title}
                    data-value={swatch.title}
                >
                    {' '}
                    <img src={require('../../../../static/icons/ok.png')} alt="" data-img="img-only" />
                </span>
                <Tooltip id={`upsell-swatch-${swatch.value_index}`} variant="light" />
            </SwatchOption>
        );
    });

    return (
        <div className={classes.upsellSwatches}>
            <div className={classes.upsellSwatchHeader}>
                <small className={classes.upsellSwatchesCount} data-test-id="ProductSwatch_SwatchCount">
                    <strong>
                        {swatchTotal} Colour{swatchTotal > 1 ? 's' : ''}
                    </strong>{' '}
                    Available
                </small>
            </div>
            <div className={classes.upsellSwatchesList} data-test-id="ProductSwatch_SwatchList">
                <div
                    className={classnames({
                        [classes.upsellSwatchesContainer]: true,
                        [classes.upsellSwatchesContainerMore]: !showMore,
                    })}
                >
                    {swatchItems}
                </div>
            </div>
        </div>
    );
};
